/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取积分说明
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  integralReq: member.IntegralReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.IntegralRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/integral/explain`,
    data: integralReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
